import { combineReducers } from "redux";
import occupanciesReducer from "./PastOccupancies/occupanciesReducer";
import pastOccupanciesReducer from "./PastOccupancies/pastOccupanciesReducer";
import currentOccupanciesReducer from "./CurrentOccupancies/currentOccupanciesReducer";
import educationReducer from "./Education/educationReducer";
import treatmentCentersReducer from "./TreatmentCenters/treatmentCentersReducer";
import occupationsReducer from "./Occupations/occupationsReducer";
import familyMembersReducer from "./FamilyMembers/familyMembersReducer"
import therapistsReducer from "./Therapists/therapistsReducer";
import insurancesReducer from "./Insurance/insuranceReducer";
import livingArrangementsReducer from "./LivingArrangements/livingArrangementHistoriesReducer";
import probationsReducer from "./Probations/probationReducer";
import abuseExperiencesReducer from "./AbuseExperiences/abuseExperiencesReducer";
import sobrietiesReducer from "./Sobrieties/sobrietiesReducer";
import contactsReducer from "./Contacts/contactsReducer";
import documentsReducer from "./Documents/documentsReducer";
import notesReducer from "./Notes/notesReducer";
import medicationsReducer from "./Medications/medicationsReducer";
import transactionsReducer from "./Transactions/transactionsReducer";
import checkinsReducer from "./Checkins/checkinsReducer";
import goalsReducer from "./Goals/goalsReducer";
import soberLivingsReducer from "./SoberLivings/soberLivingsReducer";
import uiReducer from "./uiReducer";
import counselingHistoriesReducer from "./CounselingHistories/counselingHistoriesReducer";
import childWelfareHistoriesReducer from "./ChildWelfareHistories/childWelfareHistoriesReducer";

// payments tab
import addBalanceForm from '../Resident/tabs/PaymentsTab/components/Account/components/AddBalanceForm/reducer'
import availableFundsHistory from '../Resident/tabs/PaymentsTab/components/Account/components/AvailableFundsHistory/reducer'
import paymentSources from '../Resident/tabs/PaymentsTab/components/Account/components/PaymentSources/reducer'
import account from '../Resident/tabs/PaymentsTab/components/Account/reducer'
import pendingInvoices from '../Resident/tabs/PaymentsTab/components/PendingInvoices/reducer'
import newInvoiceForm from '../Resident/tabs/PaymentsTab/components/PendingInvoices/components/NewInvoiceForm/reducer'
import makePaymentForm from '../Resident/tabs/PaymentsTab/components/PendingInvoices/components/MakePaymentForm/reducer'
import recurringCharges from '../Resident/tabs/PaymentsTab/components/RecurringCharges/reducer'
import newPaymentSourceForm from '../Resident/tabs/PaymentsTab/components/Account/components/PaymentSources/components/NewPaymentSourceForm/reducer'
import newRecurringChargeForm from '../Resident/tabs/PaymentsTab/components/RecurringCharges/components/NewRecurringChargeForm/reducer'
import transactionHistory from '../Resident/tabs/PaymentsTab/components/TransactionHistory/reducer'
import newTransactionForm from '../Resident/tabs/PaymentsTab/components/TransactionHistory/components/NewTransactionForm/reducer'
import masterNewChargeForm from '../Resident/tabs/PaymentsTab/components/Account/components/MasterNewChargeForm/reducer'
import paidInvoices from '../Resident/tabs/PaymentsTab/components/PaidInvoices/reducer'
import editRecurringChargeForm from '../Resident/tabs/PaymentsTab/components/RecurringCharges/components/EditRecurringCharge/reducer'
import editPendingInvoiceForm from '../Resident/tabs/PaymentsTab/components/PendingInvoices/components/EditPendingInvoice/reducer'
import verifyPaymentSourceForm from '../Resident/tabs/PaymentsTab/components/Account/components/PaymentSources/components/VerifyPaymentSourceForm/reducer'
import vaccinesReducer from "./Vaccines/vaccinesReducer";
import testsReducer from "./Tests/testsReducer";
import publicBenefitsReducer from "./PublicBenefits/publicBenefitsReducer";
import programHistoriesReducer from "./ProgramHistories/programHistoriesReducer";
import criminalHistoryReducer from "./CriminalHistory/criminalHistoryReducer";
import medicinalMarijuanaReducer from "./MedicinalMarijuana/medicinalMarijuanaReducer";
import canAddOccupancyReducer from "./CurrentOccupancies/canAddOccupancyReducer";

const residentReducer = (state = {}, action) => {
  switch (action.type) {
    case "UPDATE_RESIDENT":
      return { ...state, [action.payload.name]: action.payload.value };
    default:
      return state;
  }
}

export default combineReducers({
  account,
  addBalanceForm,
  availableFundsHistory,
  editPendingInvoiceForm,
  editRecurringChargeForm,
  makePaymentForm,
  masterNewChargeForm,
  newInvoiceForm,
  newPaymentSourceForm,
  newRecurringChargeForm,
  newTransactionForm,
  paidInvoices,
  paymentSources,
  pendingInvoices,
  recurringCharges,
  transactionHistory,
  verifyPaymentSourceForm,

  calendars: (state = {}) => state,
  checkins: checkinsReducer,
  goal_subscriptions: goalsReducer,
  config: (state = {}) => state,
  contacts: contactsReducer,
  current_user: (state = {}) => state,
  documents: documentsReducer,
  drug_tests: (state = {}) => state,
  educations: educationReducer,
  groups: (state = []) => state,
  insurances: insurancesReducer,
  criminal_history: criminalHistoryReducer,
  medicinal_marijuana: medicinalMarijuanaReducer,
  living_arrangement_histories: livingArrangementsReducer,
  probations: probationsReducer,
  abuse_experiences: abuseExperiencesReducer,
  medical_tests: testsReducer,
  medications: medicationsReducer,
  mentors: (state = []) => state,
  notes: notesReducer,
  occupancies: occupanciesReducer,
  past_occupancies: pastOccupanciesReducer,
  current_occupancies: currentOccupanciesReducer,
  family_members: familyMembersReducer,
  public_benefits: publicBenefitsReducer,
  program_histories: programHistoriesReducer,
  occupations: occupationsReducer,
  organization: (state = {}) => state,
  outcomes: (state = {}) => state,
  org_dependant_data: (state = {}) => state,
  paymentInfo: (state = {}) => state,
  permissions: (state = {}) => state,
  resident: residentReducer,
  sober_livings: soberLivingsReducer,
  sobrieties: sobrietiesReducer,
  survey_submissions: (state = {}) => state,
  stripe_api_key: (state = '') => state,
  tabs: (state = {}) => state,
  therapists: therapistsReducer,
  transactions: transactionsReducer,
  treatment_centers: treatmentCentersReducer,
  users: (state = {}) => state,
  ui: uiReducer,
  vaccines: vaccinesReducer,
  counseling_histories: counselingHistoriesReducer,
  child_welfare_histories: childWelfareHistoriesReducer,
  can_add_occupancy: canAddOccupancyReducer,
});
